import { render, staticRenderFns } from "./FacturacionPolitics.vue?vue&type=template&id=22ee3770&scoped=true"
import script from "./FacturacionPolitics.vue?vue&type=script&lang=js"
export * from "./FacturacionPolitics.vue?vue&type=script&lang=js"
import style0 from "./FacturacionPolitics.vue?vue&type=style&index=0&id=22ee3770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ee3770",
  null
  
)

export default component.exports